import {
    SHOW_SETTINGS_SIDE_MENU, HIDE_SETTINGS_SIDE_MENU
} from './actionTypes.jsx';

export function showSettingsSideMenu() {
   return {
    type: SHOW_SETTINGS_SIDE_MENU,
    payload: {}
  }
}

export function hideSettingsSideMenu() {
  return {
    type: HIDE_SETTINGS_SIDE_MENU,
    payload: {}
  }
}
